var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.3337 0.666016H5.66699C2.90949 0.666016 0.666992 2.90852 0.666992 5.66602V16.4993C0.666992 16.7204 0.75479 16.9323 0.91107 17.0886C1.06735 17.2449 1.27931 17.3327 1.50033 17.3327H12.3337C15.0912 17.3327 17.3337 15.0902 17.3337 12.3327V5.66602C17.3337 2.90852 15.0912 0.666016 12.3337 0.666016ZM6.49949 13.166H4.83366V11.5002L9.44199 6.89852L11.1078 8.56435L6.49949 13.166ZM11.8937 7.77852L10.2278 6.11268L11.4978 4.84352L13.1637 6.50935L11.8937 7.77852Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/edit_icon.6d6b14429bac235f04e2e82699094c6d.svg";
export { ForwardRef as ReactComponent };